// extracted by mini-css-extract-plugin
export default {"noChange":"noChange_DiffIcon-module_TgJIC"};